module.exports = __webpack_public_path__ + "img/chevron.21644c80.svg";